import { Storage } from '../../Consts/Storage';
export default class AppUtil {
}
// サーバーのURL生成
AppUtil.cvtRemotePath = (file, dir) => {
    const path = dir ? `${dir}/${file}` : file;
    return `${Storage.REMOTE_BASE_URL}/${path}`;
};
